import {computed} from 'vue';
import {useTimeAllocationCategoriesStore} from '../stores/timeAllocationCategories.store.ts';

export function useCategoryVisibility() {
  const categoriesStore = useTimeAllocationCategoriesStore();

  // Separate used and unused categories based on usage count
  const usedCategories = computed(() => {
    return categoriesStore.active.filter(category => category.usageCount > 0);
  });

  const unusedCategories = computed(() => {
    return categoriesStore.active.filter(category => category.usageCount === 0);
  });

  // Get categories to show in the chips (either all used categories, or all if none used)
  function getCategoriesToShow(showUnusedCategories: boolean) {
    const hasUsedCategories = usedCategories.value.length > 0;
    
    if (hasUsedCategories) {
      // If there are used categories, show used ones + unused ones if toggled
      return showUnusedCategories ? categoriesStore.active : usedCategories.value;
    } else {
      // If no categories were used, show all categories
      return categoriesStore.active;
    }
  }

  // Check if we should show the "more..." link
  const shouldShowMoreLink = computed(() => {
    return usedCategories.value.length > 0 && unusedCategories.value.length > 0;
  });

  return {
    usedCategories,
    unusedCategories,
    shouldShowMoreLink,
    getCategoriesToShow
  };
}
